import axios from 'axios'
import { useUserStore } from '@/stores/user'

// Configuración base de axios para el módulo de finanzas
const apiFinanzas = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8000/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Interceptor para agregar el token JWT y negocio_id en cada petición
apiFinanzas.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // Agregar negocio_id si está seleccionado
    const userStore = useUserStore()
    if (userStore.negocioSeleccionado?.id) {
      config.headers['X-Negocio-Id'] = userStore.negocioSeleccionado.id
      console.log('[apiFinanzas] X-Negocio-Id agregado:', userStore.negocioSeleccionado.id)
    } else {
      console.warn('[apiFinanzas] No hay negocio seleccionado')
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para manejar respuestas y errores
apiFinanzas.interceptors.response.use(
  (response) => {
    // Si la respuesta tiene el formato { success: true, data: ... }
    if (response.data && response.data.success) {
      return response.data
    }
    return response.data
  },
  (error) => {
    // Manejar errores de autenticación
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }

    // Manejar otros errores
    const mensaje = error.response?.data?.message ||
                   error.response?.data?.error ||
                   'Error al procesar la solicitud'

    return Promise.reject({
      mensaje,
      status: error.response?.status,
      errors: error.response?.data?.errors || {}
    })
  }
)

export default apiFinanzas
